// ======================================================================
// File Name       : ReduxFormPaging
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================

import React from 'react';
import { Field } from 'redux-form';
import PaginationCustom from '../components/Pagination';
import TableCell from './TableCell';

class ReduxFormPaging extends React.Component {
  constructor(props) {
    super(props);
    this.getFieldComponent = this.getFieldComponent.bind(this);
  }
  getFieldComponent(type) {
    let fieldComponent = Paging;
    switch (type) {
      case 'paging':
        fieldComponent = Paging;
        break;
      case 'tableHead':
        fieldComponent = TableHead;
        break;
      default:
        break;
    }
    return fieldComponent;
  }

  render() {
    const {
      name,
      type,
      label,
      value,
      data,
      className = '',
      recordNum,
      getStartEndData,
      invalid,
      handleSortState,
      returnMaxNum,
    } = this.props;
    const fieldComponent = this.getFieldComponent(type);
    return (
      <Field
        name={name}
        type={type}
        component={fieldComponent}
        label={label}
        data={data}
        className={className}
        recordNum={recordNum}
        getStartEndData={getStartEndData}
        invalid={invalid}
        handleSortState={handleSortState}
        returnMaxNum={returnMaxNum}
      />
    );
  }
}

function TableHead(props) {
  const {
    input: { ...inputProps },
    meta: { error, warning, initial, pristine, submitFailed },
    data,
    invalid,
    handleSortState,
  } = props;
  const sortingCell = pristine ? initial : inputProps.value;
  const headData = data.map((el, i) => ({ index: i, isSort: false, sortState: 0, ...el }));
  const th = headData.map((item, index) => {
    if (sortingCell) {
      if (index === sortingCell.index) {
        item.isSort = true;
        item.sortState = sortingCell.sortState;
      }
    }
    return (
      <TableCell
        key={index}
        cell={item}
        handleUpdateSortState={(cell) => {
          if (invalid) {
            return;
          }
          inputProps.onChange(cell);
          if (handleSortState) {
            handleSortState(cell);
          }
        }}
        width={item.width}
      />
    );
  });
  return <tr>{th}</tr>;
}

function Paging(props) {
  const {
    input: { ...inputProps },
    meta: { error, warning, initial, pristine, submitFailed },
    recordNum,
    getStartEndData,
    invalid,
    returnMaxNum,
  } = props;
  const startPosition = pristine ? initial || 0 : inputProps.value;
  return (
    <div>
      <PaginationCustom
        className="justify-content-center"
        recordNum={recordNum}
        handlePageSelect={(pos) => {
          if (invalid) {
            return;
          }
          inputProps.onChange(pos);
          if (getStartEndData) {
            getStartEndData(pos);
          }
        }}
        startPosition={startPosition}
        returnMaxNum={returnMaxNum}
      />
    </div>
  );
}

export default ReduxFormPaging;
